import { Box, Image, Stack, Text } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage, useIntl } from "react-intl";
import Breadcrumbs from "../../components/Breadcrumbs";
import CenteredContent from "../../components/CenteredContent";
import Landing from "../../components/Landing";
import WaveContainer from "../../components/WaveContainer/WaveContainer";
import ContactAndSubscribe from "./ContactAndSubscribe";
import PricesRecreationalCenter from "./PricesRecreationalCenter";
import PricesWednesday from "./PricesWednesday";

function Childhood() {
  const intl = useIntl();

  return (
    <>
      <Landing
        src={generateFrontPath({
          id: "internal-assets",
          parameters: { filePath: "landing-childhood.png" },
          includeBasePath: true,
        })}>
        <Breadcrumbs
          renderOnMobile={true}
          items={[
            {
              title: intl.formatMessage({ defaultMessage: "Accueil" }),
              url: generateFrontPath({ id: "@home" }),
            },
            {
              title: intl.formatMessage({ defaultMessage: "Enfance" }),
            },
          ]}
        />

        <Text fontSize="3rem" fontWeight={400} lineHeight="normal" mt="1rem">
          <FormattedMessage defaultMessage="Enfance" />
        </Text>
      </Landing>

      <Stack spacing="2rem">
        <Box px="1rem">
          <CenteredContent maxWidth="1280px">
            <Text
              fontSize="1.5rem"
              fontWeight={400}
              lineHeight="28.8px"
              color="gray.500"
              mt="2.1875rem">
              <FormattedMessage defaultMessage="Découvrez nos services de garderie et les activités proposées aux enfants pour les mercredis et les vacances scolaires." />
            </Text>

            <Text
              fontSize="1.5rem"
              fontWeight={400}
              lineHeight="28.8px"
              color="gray.500"
              mt="2rem">
              <FormattedMessage defaultMessage="Le Centre Social Louise Michel propose des tarifs adaptés pour les résidents de Golbey et selon votre situation familiale." />
            </Text>
          </CenteredContent>
        </Box>

        <Box>
          <CenteredContent maxWidth="1600px">
            <Stack
              direction={{ base: "column", lg: "row" }}
              spacing="0"
              alignItems="center">
              <Box flexGrow={1} flexBasis={0}>
                <Box pr="1.5rem">
                  <Image
                    src={generateFrontPath({
                      id: "internal-assets",
                      parameters: { filePath: "childhood-1.png" },
                      includeBasePath: true,
                    })}
                    w="full"
                    sx={{
                      "@media screen and (min-width: 1600px)": {
                        maskImage:
                          "linear-gradient(to right, transparent 0%, black 15%)",
                      },
                    }}
                    alt="Enfance"
                  />
                </Box>
              </Box>

              <Box flexGrow={1} flexBasis={0}>
                <Stack
                  spacing="1.5rem"
                  maxW="calc(640px + 1rem)"
                  px="1rem"
                  my="1.5rem">
                  <Text fontSize="1.875rem" fontWeight={400} lineHeight="36px">
                    <FormattedMessage defaultMessage="La halte garderie" />
                  </Text>

                  <Text
                    fontSize="1.25rem"
                    fontWeight={400}
                    lineHeight="1.75rem">
                    <FormattedMessage defaultMessage="Garde des enfants de 10 semaines à 3 ans, lundi au vendredi (sauf mercredi) de 8h à 18h." />
                  </Text>

                  <Text
                    fontSize="1.25rem"
                    fontWeight={500}
                    lineHeight="1.75rem">
                    <FormattedMessage defaultMessage="Tarifs de garderie" />
                  </Text>

                  <Text
                    fontSize="1.25rem"
                    fontWeight={400}
                    lineHeight="1.75rem">
                    <FormattedMessage defaultMessage="De 0,16 € à 3,71€/heure selon critères sociaux." />
                  </Text>

                  <ContactAndSubscribe />
                </Stack>
              </Box>
            </Stack>
          </CenteredContent>
        </Box>

        <Box>
          <WaveContainer>
            <Box backgroundColor="gray.50">
              <CenteredContent maxWidth="1600px">
                <Stack
                  direction={{ base: "column-reverse", lg: "row" }}
                  spacing="0"
                  alignItems="center">
                  <Box flexGrow={1} flexBasis={0}>
                    <Stack
                      spacing="1.5rem"
                      maxW="calc(640px + 1rem)"
                      px="1rem"
                      ml="auto"
                      my="1.5rem">
                      <Text
                        fontSize="1.875rem"
                        fontWeight={400}
                        lineHeight="36px">
                        <FormattedMessage defaultMessage="Les mercredis récréatifs" />
                      </Text>

                      <Text
                        fontSize="1.25rem"
                        fontWeight={400}
                        lineHeight="1.75rem">
                        <FormattedMessage defaultMessage="Accueil des enfants de 3 à 14 ans tous les mercredis pour une demi-journée ou la journée entière." />
                      </Text>

                      <PricesWednesday />

                      <ContactAndSubscribe />
                    </Stack>
                  </Box>

                  <Box flexGrow={1} flexBasis={0}>
                    <Box pl="1.5rem">
                      <Image
                        src={generateFrontPath({
                          id: "internal-assets",
                          parameters: { filePath: "childhood-2.png" },
                          includeBasePath: true,
                        })}
                        w="full"
                        sx={{
                          "@media screen and (min-width: 1600px)": {
                            maskImage:
                              "linear-gradient(to right, black 85%, transparent 100%)",
                          },
                        }}
                        alt="Enfance"
                      />
                    </Box>
                  </Box>
                </Stack>
              </CenteredContent>
            </Box>
          </WaveContainer>
        </Box>

        <Box>
          <CenteredContent maxWidth="1600px">
            <Stack
              direction={{ base: "column", lg: "row" }}
              spacing="0"
              alignItems="center">
              <Box flexGrow={1} flexBasis={0}>
                <Box pr="1.5rem">
                  <Image
                    src={generateFrontPath({
                      id: "internal-assets",
                      parameters: { filePath: "childhood-3.png" },
                      includeBasePath: true,
                    })}
                    w="full"
                    sx={{
                      "@media screen and (min-width: 1600px)": {
                        maskImage:
                          "linear-gradient(to right, transparent 0%, black 15%)",
                      },
                    }}
                    alt="Enfance"
                  />
                </Box>
              </Box>

              <Box flexGrow={1} flexBasis={0}>
                <Stack
                  spacing="1.5rem"
                  maxW="calc(640px + 1rem)"
                  px="1rem"
                  my="1.5rem">
                  <Text fontSize="1.875rem" fontWeight={400} lineHeight="36px">
                    <FormattedMessage defaultMessage="Le centre aéré" />
                  </Text>

                  <Text
                    fontSize="1.25rem"
                    fontWeight={400}
                    lineHeight="1.75rem">
                    <FormattedMessage defaultMessage="Accueil des enfants de 3 à 14 ans." />
                  </Text>

                  <Box>
                    <Text
                      fontSize="1.25rem"
                      fontWeight={400}
                      lineHeight="1.75rem">
                      <FormattedMessage defaultMessage="Les activités ont lieu de 9h à 12h et de 14h à 17h. Un accueil autour d’ateliers libres fonctionne tous les jours de 7h30 à 9h et de 17h à 18h30." />
                    </Text>

                    <Text
                      fontSize="1.25rem"
                      fontWeight={400}
                      lineHeight="1.75rem">
                      <FormattedMessage defaultMessage="Les places sont limitées, merci de réserver votre place au plus vite." />
                    </Text>
                  </Box>

                  <PricesRecreationalCenter />

                  <ContactAndSubscribe />
                </Stack>
              </Box>
            </Stack>
          </CenteredContent>
        </Box>
      </Stack>
    </>
  );
}

export default Childhood;
